import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';
import _ from 'lodash';
import * as status from 'modules/app/constants/crudStatus';
import { VISIT_AND_UNITS, GET_GOODS, STORE_GOOD, DELETE_GOOD, DOCS_AND_GOODS } from '../constants/actionTypes';
import { serverGoodToClientMap } from 'app/businessRules';

const INITIAL_STATE = {
    status: status.INITIAL,
    goods: []
};

const findIndex = (state, id) => (
    _.findIndex(state.get('goods').toJS(), {id})
);

export default createReducer(['goods'], (state = fromJS(INITIAL_STATE), action) => {

    switch (action.type) {

        case GET_GOODS.REQUEST:
            return state.set('status', status.LOADING).set('goods', fromJS(INITIAL_STATE.goods));

        case GET_GOODS.ERROR:
            return state.set('status', status.ERROR).set('goods', fromJS(INITIAL_STATE.goods));

        case GET_GOODS.SUCCESS:
            return state.set('status', status.SUCCESS).set('goods', fromJS(serverGoodToClientMap(action.goods)));

        case STORE_GOOD.SUCCESS:
            const goodIndex = findIndex(state,action.good.id);
            if (goodIndex > -1) {
                return state.set('goods', state.get('goods').set(goodIndex, fromJS(serverGoodToClientMap(action.good))));
            } else {
                return state.set('goods', state.get('goods').push(fromJS(serverGoodToClientMap(action.good))));
            }

        case DELETE_GOOD.SUCCESS:
            const index = findIndex(state, action.id);
            return state.set('goods', state.get('goods').delete(index));

        case DOCS_AND_GOODS.CLEAR:
        case VISIT_AND_UNITS.CLEAR:
            return fromJS(INITIAL_STATE);

        default:
            break;
    }

    return state;
});